﻿var CreatedOKLodop7766 = null, CLodopIsLocal;
import { MessageBox } from 'element-ui';
//====判断是否需要 Web打印服务CLodop:===
//===(不支持插件的浏览器版本需要用它)===
function needCLodop() {
    try {        
        return true;
    } catch (err) {
        return true;
    }
}

//====页面引用CLodop云打印必须的JS文件,用双端口(8000和18000）避免其中某个被占用：====
if (needCLodop()) {
    var src1 = "https://localhost.lodop.net:8443/CLodopfuncs.js?priority=1";
    // var src2 = "https://localhost:8444/CLodopfuncs.js?priority=0";

    var head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
    var oscript = document.createElement("script");
    oscript.src = src1;
    head.insertBefore(oscript, head.firstChild);
    oscript = document.createElement("script");
    // oscript.src = src2;
    // head.insertBefore(oscript, head.firstChild);
    CLodopIsLocal = !!((src1).match(/\/\/localho|\/\/127.0.0./i));
}

//====获取LODOP对象的主过程：====
function getLodop(oOBJECT, oEMBED) {
    const baseUrl = process.env.API_IMG_URL+'upload/lodop/';
    var exe_32=baseUrl+'install_lodop32.exe';
    var exe_64=baseUrl+'install_lodop64.exe';
    var exe_32NT=baseUrl+'CLodop_Setup_for_Win64NT_4.145EN.exe';
    var strHtmInstall = "<font>打印控件未安装!点击这里<a href='"+exe_32+"' target='_blank' style='display: inline;color:#FF00FF'>执行安装</a>,安装后请刷新页面或重新进入。</font>";
    var strHtmUpdate = "<font>打印控件需要升级!点击这里<a href='"+exe_32+"' target='_blank' style='display: inline;color:#FF00FF'>执行升级</a>,升级后请重新进入。</font>";
    var strHtm64_Install = "<font>打印控件未安装!点击这里<a href='"+exe_64+"' target='_blank' style='display: inline;color:#FF00FF'>执行安装</a>,安装后请刷新页面或重新进入。</font>";
    var strHtm64_Update = "<font>打印控件需要升级!点击这里<a href='"+exe_64+"' target='_blank' style='display: inline;color:#FF00FF'>执行升级</a>,升级后请重新进入。</font>";
    var strHtmFireFox = "<font>（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）</font>";
    var strHtmChrome = "<font>(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）</font>";
    var strCLodopInstall_1 = "<font>Web打印服务CLodop未安装启动，点击这里<a href='"+exe_32NT+"' target='_blank' style='display: inline;color:#FF00FF'>下载执行安装</a>";
    var strCLodopInstall_2 = "（若此前已安装过，可<a href='CLodop.protocol:setup' target='_blank' style='display: inline;color:#FF00FF'>点这里直接再次启动</a>）";
    var strCLodopInstall_3 = "，成功后请刷新本页面。</font>";
    var strCLodopUpdate = "<font>Web打印服务CLodop需升级!点击这里<a href='"+exe_32NT+"' target='_blank' style='display: inline;color:#FF00FF'>执行升级</a>,升级后请刷新页面。</font>";
    var LODOP;
    try {
        var ua = navigator.userAgent;
        var isIE = !!(ua.match(/MSIE/i)) || !!(ua.match(/Trident/i));
        if (needCLodop()) {
            try {
                LODOP = getCLodop();
            } catch (err) {}
            if (!LODOP && document.readyState !== "complete") {
                alert("网页还没下载完毕，请稍等一下再操作.");
                return;
            }
            if (!LODOP) {
                MessageBox.alert(strCLodopInstall_1 + (CLodopIsLocal ? strCLodopInstall_2 : "") + strCLodopInstall_3, '警告', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText:'刷新',
                    callback: action => {
                        window.location.reload();
                    }
                });
                // document.body.innerHTML = strCLodopInstall_1 + (CLodopIsLocal ? strCLodopInstall_2 : "") + strCLodopInstall_3 + document.body.innerHTML;
                return;
            } else {
                if (CLODOP.CVERSION < "3.0.4.8") {
                    MessageBox.alert(strCLodopUpdate, '警告', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText:'刷新',
                        callback: action => {
                            window.location.reload();
                        }
                    });
                    // document.body.innerHTML = strCLodopUpdate + document.body.innerHTML;
                }
                if (oEMBED && oEMBED.parentNode)
                    oEMBED.parentNode.removeChild(oEMBED);
                if (oOBJECT && oOBJECT.parentNode)
                    oOBJECT.parentNode.removeChild(oOBJECT);
            }
        } else {
            var is64IE = isIE && !!(ua.match(/x64/i));
            //=====如果页面有Lodop就直接使用，没有则新建:==========
            if (oOBJECT || oEMBED) {
                if (isIE)
                    LODOP = oOBJECT;
                else
                    LODOP = oEMBED;
            } else if (!CreatedOKLodop7766) {
                LODOP = document.createElement("object");
                LODOP.setAttribute("width", 0);
                LODOP.setAttribute("height", 0);
                LODOP.setAttribute("style", "position:absolute;left:0px;top:-100px;width:0px;height:0px;");
                if (isIE)
                    LODOP.setAttribute("classid", "clsid:2105C259-1E0C-4534-8141-A753534CB4CA");
                else
                    LODOP.setAttribute("type", "application/x-print-lodop");
                document.documentElement.appendChild(LODOP);
                CreatedOKLodop7766 = LODOP;
            } else
                LODOP = CreatedOKLodop7766;
            //=====Lodop插件未安装时提示下载地址:==========
            if ((!LODOP) || (!LODOP.VERSION)) {
                if (ua.indexOf('Chrome') >= 0)
                    MessageBox.alert(strHtmChrome, '警告', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText:'刷新',
                        callback: action => {
                            window.location.reload();
                        }
                    });
                    // document.body.innerHTML = strHtmChrome + document.body.innerHTML;
                if (ua.indexOf('Firefox') >= 0)
                    MessageBox.alert(strHtmFireFox +  (is64IE ? strHtm64_Install : strHtmInstall), '警告', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText:'刷新',
                        callback: action => {
                            window.location.reload();
                        }
                    });
                    // document.body.innerHTML = strHtmFireFox + document.body.innerHTML;
                    // document.body.innerHTML = (is64IE ? strHtm64_Install : strHtmInstall) + document.body.innerHTML;
                return LODOP;
            }
        }
        if (LODOP.VERSION < "6.2.2.3") {
            if (!needCLodop()){
                MessageBox.alert( (is64IE ? strHtm64_Update : strHtmUpdate) , '警告', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText:'刷新',
                    callback: action => {
                        window.location.reload();
                    }
                });
                
                // document.body.innerHTML = (is64IE ? strHtm64_Update : strHtmUpdate) + document.body.innerHTML;
            }
            return LODOP;
        }
        //===如下空白位置适合调用统一功能(如注册语句、语言选择等):===

        //=======================================================
        return LODOP;
    } catch (err) {
        alert("getLodop出错:" + err);
    }
}

const LodopPlugin = {}
LodopPlugin.install = function (Vue, options) {
 // 4. 添加实例方法
 Vue.prototype.$getLodop = getLodop
}
export default LodopPlugin


//////////////////
// WEBPACK FOOTER
// ./static/js/lodop/LodopFuncs.js
// module id = null
// module chunks = 